import { createContext } from "react";


const defaultValue = {
  theme: false,
  setTheme: () => {} 
}

export default createContext(defaultValue);
